import { Navigate, useParams } from 'react-router-dom'
import { ORDER_PATHS } from '../constants/orders'

export function LegacyOrderRedirect() {
  const { id } = useParams()
  return <Navigate to={id ? ORDER_PATHS.detail(id) : ORDER_PATHS.list} replace />
}
